// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IValidateAddressWebRequest,
  TValidateAddressWebModel,
  IMappers,
  TValidateAddressWebResponse,
  IValidateAddressWebResponse,
  IValidateAddressWebResponseError,
} from './types';

export const defaultConfig: TValidateAddressWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v1/validate-address-web/',
} as TValidateAddressWebModel;

export function createValidateAddressWebModel(parameters: IValidateAddressWebRequest): TValidateAddressWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IValidateAddressWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IValidateAddressWebRequest;
}

export async function fetchValidateAddressWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IValidateAddressWebOptions<TResponse200, TResponse400>): Promise<
  TValidateAddressWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createValidateAddressWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IValidateAddressWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IValidateAddressWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TValidateAddressWebResponse;
}
